import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 54,
    seconds: 27
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };else if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };else if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  const Digit = ({
    value
  }: {
    value: number;
  }) => <div className="bg-[#0f172a] px-3 py-2 md:px-6 md:py-4 rounded-lg md:rounded-xl border-2 border-[#22c55e]/30 min-w-[64px] md:min-w-[110px] relative overflow-hidden shadow-inner" data-id="element-81">
      <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" data-id="element-82"></div>
      <div className="absolute top-1/2 left-0 w-full h-px bg-black/50" data-id="element-83"></div>
      <AnimatePresence mode="popLayout" data-id="element-84">
        <motion.span key={value} initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: -20,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="block" data-id="element-85">
          {formatTime(value)}
        </motion.span>
      </AnimatePresence>
    </div>;
  return <section className="py-6 md:py-12 px-4 max-w-4xl mx-auto" data-id="element-86">
      <FadeIn data-id="element-87">
        <div className="text-center mb-4 md:mb-8" data-id="element-88">
          <h2 className="text-lg md:text-3xl font-black text-[#0f172a] flex items-center justify-center gap-2 md:gap-3 tracking-widest" data-id="element-89">
            <span className="text-2xl md:text-3xl animate-bounce" data-id="element-90">⏰</span>{' '}
            PRECIO DE LANZAMIENTO
          </h2>
        </div>

        <div className="bg-[#020617] border-2 border-[#ef4444]/50 rounded-2xl md:rounded-3xl p-5 md:p-12 text-center relative overflow-hidden shadow-[0_20px_50px_rgba(2,6,23,0.2)]" data-id="element-91">
          <motion.div animate={{
          backgroundPosition: ['0% 0%', '100% 0%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} className="absolute top-0 left-0 w-full h-2 bg-[linear-gradient(90deg,#ef4444,#22c55e,#ef4444,#22c55e)] bg-[length:200%_100%]" data-id="element-92"></motion.div>

          <div className="flex justify-center items-center gap-1.5 md:gap-4 text-4xl md:text-7xl font-black font-mono mb-5 md:mb-10 text-white" data-id="element-93">
            <Digit value={timeLeft.hours} data-id="element-94" />
            <span className="text-[#22c55e] pb-2 animate-pulse" data-id="element-95">:</span>
            <Digit value={timeLeft.minutes} data-id="element-96" />
            <span className="text-[#22c55e] pb-2 animate-pulse" data-id="element-97">:</span>
            <div className="text-[#ef4444] drop-shadow-[0_0_10px_rgba(239,68,68,0.5)]" data-id="element-98">
              <Digit value={timeLeft.seconds} data-id="element-99" />
            </div>
          </div>

          <div className="space-y-4 md:space-y-8" data-id="element-100">
            <div className="inline-flex items-center justify-center gap-2 md:gap-3 bg-[#ef4444]/10 border border-[#ef4444]/20 px-4 md:px-6 py-2 md:py-3 rounded-full" data-id="element-101">
              <AlertTriangle className="text-[#22c55e] w-4 h-4 md:w-6 md:h-6" data-id="element-102" />
              <p className="text-sm md:text-xl font-bold text-[#22c55e]" data-id="element-103">
                Después sube $15.000 ARS. No vuelve.
              </p>
            </div>

            <div className="max-w-xl mx-auto bg-[#0f172a] p-4 md:p-6 rounded-xl md:rounded-2xl border border-[#22c55e]/20" data-id="element-104">
              <div className="flex justify-between text-xs md:text-base font-bold mb-2 md:mb-3 text-[#e2e8f0] uppercase tracking-wider" data-id="element-105">
                <span className="flex items-center gap-2" data-id="element-106">
                  <span className="w-3 h-3 rounded-full bg-[#ef4444] animate-pulse shadow-[0_0_10px_rgba(239,68,68,0.8)]" data-id="element-107"></span>
                  Cupos tomados
                </span>
                <span className="text-[#ef4444]" data-id="element-108">78%</span>
              </div>
              <div className="w-full bg-[#020617] rounded-full h-3 md:h-4 overflow-hidden border border-[#22c55e]/20 relative" data-id="element-109">
                <motion.div initial={{
                width: 0
              }} animate={{
                width: '78%'
              }} transition={{
                duration: 1.5,
                ease: 'easeOut'
              }} className="h-full rounded-full bg-[#ef4444] relative overflow-hidden" data-id="element-110">
                  <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.2)_25%,rgba(255,255,255,0.2)_50%,transparent_50%,transparent_75%,rgba(255,255,255,0.2)_75%,rgba(255,255,255,0.2)_100%)] bg-[length:20px_20px] animate-[progress-stripes_1s_linear_infinite]" data-id="element-111"></div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
      <style data-id="element-112">{`
        @keyframes progress-stripes {
          from { background-position: 20px 0; }
          to { background-position: 0 0; }
        }
      `}</style>
    </section>;
}